import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=f7e7bcf0&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=f7e7bcf0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7e7bcf0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f7e7bcf0')) {
      api.createRecord('f7e7bcf0', component.options)
    } else {
      api.reload('f7e7bcf0', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=f7e7bcf0&scoped=true&", function () {
      api.rerender('f7e7bcf0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-21TrLsfg678Pn/JS/comp/GuestBox.vue"
export default component.exports